import * as React from 'react';
import {
  LoadingParagraph,
  LoadingError,
} from '../core/DashbardGridStyledComponents';

export const withDataFetch = (WrappedComponent: any) => (props: any) => {
  const { data, view, options, ...others } = props;
  const [isError, setIsError] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const [renderData, setRenderData] = React.useState({});

  React.useEffect(() => {
    const fetchData = async () => {
      setIsError(false);
      setLoading(true);
      try {
        fetch(data.url)
          .then(res => {
            // console.log(res);
            if (res.ok) {
              return res.json();
            } else {
              throw Error(`Request rejected with status ${res.status}`);
            }
          })
          .then((res: any) => {
            setRenderData(res);
            setLoading(false);
            setIsError(false);
          })
          .catch(err => {
            setIsError(err.message);
            setLoading(false);
          });
      } catch (_) {
        setIsError(true);
        setLoading(false);
      }
    };
    fetchData();
  }, [data.url]);

  const modifiedOptions = { ...view, ...options };
  return (
    <>
      {isLoading && <LoadingParagraph>Loading...</LoadingParagraph>}
      {isError && (
        <LoadingError>{`Error Loading Data: ${isError}`}</LoadingError>
      )}
      {!isLoading && !isError && (
        <React.Suspense fallback="loading...">
          <WrappedComponent
            data={renderData}
            options={modifiedOptions}
            {...others}
          />
        </React.Suspense>
      )}
    </>
  );
};
